import React from 'react';
import FormComponent from '../../common/FormComponent';
import Validators from '../../constants/ValidatorTypes';
import { getDeceasedBroughtById, editDeceasedBrought } from '../../services/deceasedBrought/DeceasedBroughtService';
import strings from "../../localization";
import DeceasedBroughtForm from '../../components/forms/deceasedBrought/DeceasedBroughtForm';
import { bindActionCreators } from "redux";
import { withSnackbar } from 'notistack';
import connect from "react-redux/es/connect/connect";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { Paper } from "@material-ui/core";


class EditDeceasedBrought extends FormComponent {
  validationList = {
    name: [{ type: Validators.REQUIRED }]
  };

  constructor(props) {
    super(props);

    this.state = {
      data: props.data ? props.data : {},
      errors: {}
    };

    this.props.changeFullScreen(false);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    getDeceasedBroughtById(this.props.id).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  submit() {
    if (!this.validate()) {
      return;
    }

    this.showDrawerLoader();

    editDeceasedBrought(this.transformRequest(this.state.data)).then(response => {
      if (!response.ok) {
        let messageKey = response.response.data.message;

        this.props.enqueueSnackbar(strings.deceasedBrought.messages[messageKey], { variant: 'error' });
        this.handleError(messageKey);
        return;
      }

      this.props.enqueueSnackbar(strings.deceasedBrought.editForm.edited, { variant: 'success' });
      this.props.onFinish(response.data);
      this.hideDrawerLoader();
    });

  }

  transformRequest(data) {
    return {
      ...data,
      userEmail: this.props.uemail,
      companyId: this.props.cid
    }
  }

  handleError(message) {
    switch (message) {
      case "DECEASED_WITH_NAME_ALREADY_EXIST":
        this.setError("name", strings.deceasedBrought.messages.DECEASED_WITH_NAME_ALREADY_EXIST);
        break;

      case "DECEASED_NOT_EXIST":
        this.setError("name", strings.deceasedBrought.messages.DECEASED_NOT_EXIST);
        break;

      case "DECEASED_NAME_CANT_BE_NULL":
        this.setError("name", strings.deceasedBrought.messages.DECEASED_NAME_CANT_BE_NULL);
        break;
    }
  }

  render() {
    return (
      <Grid id="page" item md={12}>
        <div className="header">
          <h1>{strings.deceasedBrought.editPageTitle}</h1>
        </div>

        <Paper className="paper">
          <DeceasedBroughtForm
            onChange={this.changeData}
            onSubmit={() => this.submit()}
            data={this.state.data}
            errors={this.state.errors}
            onCancel={this.props.onCancel}
            isDisabled={this.props.isDisabled}
          />
        </Paper>
      </Grid>
    );
  }

}

function mapDispatchToProps(dispatch) {

  return bindActionCreators(
    {
      changeFullScreen: Actions.changeFullScreen
    },
    dispatch
  );
}

function mapStateToProps({ menuReducers, siteDataReducers }) {

  return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(EditDeceasedBrought)
  )
);